
<!--  -->
<template>
    <div class="comContent">
        <div class="topHeader">
            <el-form ref="formTool" :model="formTool" :inline="true" style="display:flex; width:100%">
                <div style="width:calc(100% - 300px)"> 
                    <el-row v-if="!expanded">
                        <el-form-item prop="keyWords" size="small">
                            <el-input v-model="formTool.keyWords" clearable placeholder="申请人/订单编号/售后单号"
                                style="width: 300px;" />
                        </el-form-item>
                    </el-row>
                    <el-row v-if="expanded" class="serach-lf" >
                        <el-form-item prop="code" size="small">
                            <el-input v-model="formTool.payShopName" clearable placeholder="申请人" />
                        </el-form-item>
                        <el-form-item prop="orderCode" size="small">
                            <el-input v-model="formTool.orderCode" clearable placeholder="订单编号" />
                        </el-form-item>
                        <el-form-item prop="code" size="small">
                            <el-input v-model="formTool.code" clearable placeholder="售后单号" />
                        </el-form-item>
                        <el-form-item prop="status" size="small">
                            <el-select v-model="formTool.status" clearable placeholder="当前状态">
                                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-row>
                </div>

                <div style="width:300px" class="rt-btn">
                    <MyButton type="primary" text="查询" @click="getList(1)" />
                    <MyButton type="" text="重置" @click="reset()" />
                    <el-form-item v-if="isExpanded">
                        <el-button type="text" size="small" @click="handleExpand()">
                            {{ expanded ? "收起" : "展开"
                            }}
                            <i :class="{
                                    'el-icon-arrow-up': expanded,
                                    'el-icon-arrow-down': !expanded,
                                    'el-icon--right': true,
                                }"></i>
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>

        </div>
        <div class="center">
            <MyTable v-if="tableData.length > 0" :table-data="tableData" :index="index" :selection="selection" :page="page"
                :operation="operation" :table-option.sync="tableOption" @page-change="getList">

                <template slot="amount" slot-scope="scope">
                    <span>
                        ￥{{ scope.row.amount }}
                    </span>
                </template>
                <template slot="countDownTime" slot-scope="scope">
                    <!-- 审核超时时间  倒计时 -->
                    <el-statistic
                    @finish="hilarity(scope.row, scope.$index)"
                    ref="statistic" 
                    format="DD天HH:mm:ss"
                    :value="Date.now() + parseInt(scope.row.auditRemainTimestamp) "
                    title=""
                    time-indices 
                    :value-style="{ color: '#f5222d' ,fontSize:'14px' }" 
                    v-if="scope.row.auditRemainTimestamp >0 && scope.row.status == 'CHECKING' "
                  >
                  </el-statistic>
                  <!-- 发货超时时间 倒计时 -->
                  <el-statistic
                  @finish="hilarity(scope.row, scope.$index)"
                  ref="statistic" 
                  format="DD天HH:mm:ss"
                  :value="Date.now() + parseInt(scope.row.deliveryRemainTimestamp) "
                  title=""
                  time-indices 
                  :value-style="{ color: '#f5222d' ,fontSize:'14px' }" WAIT_SALE
                  v-if="scope.row.deliveryRemainTimestamp >0  && scope.row.status == 'WAIT_SALE'  "
                >
                </el-statistic>
                <!-- 收货超时时间   倒计时 -->
                <el-statistic
                @finish="hilarity(scope.row, scope.$index)"
                ref="statistic" 
                format="DD天HH:mm:ss"
                :value="Date.now() + parseInt(scope.row.receiveRemainTimestamp) "
                title=""
                time-indices 
                :value-style="{ color: '#f5222d' ,fontSize:'14px' }" 
                v-if="scope.row.receiveRemainTimestamp >0 && scope.row.status == 'SALEING' "
              >
              </el-statistic>

               <!-- 商家退款倒计时 /// ps :商户线下打款 提交打款凭证 -->

                <el-statistic @finish="hilarity(scope.row, scope.$index)" ref="statistic" format="DD天HH:mm:ss"
                    :value="Date.now() + parseInt(scope.row.offlinePaymentRefundsTimestamp)" title="" time-indices
                    :value-style="{ color: '#f5222d', fontSize: '14px' }"
                    v-if="scope.row.status === 'REFUNDING' && scope.row.offlinePaymentRefundsTimestamp > 0">
                </el-statistic>

                </template>
                <template slot="status" slot-scope="scope">
                    <span v-if="scope.row.status == 'CHECKING'">审核中</span>
                    <span v-if="scope.row.status == 'WAIT_SALE'">待退货</span>
                    <span v-if="scope.row.status == 'SALEING'">退货中</span>
                    <span v-if="scope.row.status == 'REFUNDING'">退款中</span>
                    <span v-if="scope.row.status == 'FINISH'">退款成功</span>
                    <span v-if="scope.row.status == 'REJECT'">驳回</span>
                    <span v-if="scope.row.status == 'CANCEL'">关闭</span>
                </template>
                <template slot="caozuo" slot-scope="scope">
                    <el-link type="primary" :underline="false" @click="detail(scope.row)">
                        详情
                    </el-link>
                </template>
            </MyTable>
            <el-empty v-else style="height:100%" description="暂无数据" />
        </div>
        <!-- <el-dialog title="拒绝说明" :visible.sync="dialogVisible" width="30%">
            <el-input type="textarea" placeholder="请输入内容" v-model="textarea" maxlength="200" show-word-limit>
            </el-input>
            <ImgUpload v-model="imageList" :limit="3" style="position:relative;top:-8px">
                <template slot="tip">
                    <p class="el-upload__tip" style="margin:0px">
                        备注:图片格式为jpg或png，建议尺寸100*100，图片大小不得超过5M;最多上传三张图片
                    </p>
                </template>
            </ImgUpload>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">取消</el-button>
                <el-button size="small" type="primary" @click="submit">提交</el-button>
            </span>
        </el-dialog> -->
    </div>
</template>
  
<script>
import ImgUpload from '@/components/imgUpload'
import MyButton from '@/components/myButton'
import MyTable from '@/components/myTable'
import Tabs from '@/components/Tabs'
import { aftersalePage, getOpsAfterSalesOrders } from '@/api/afterSales/serviceSheet'
export default {
    components: { MyButton, MyTable, Tabs, ImgUpload },
    data() {
        return {
            isExpanded: true,
            expanded: false,
            rowId: '',
            options: [
                {
                    label: '退货退款',
                    value: 'THTK'
                },
                {
                    label: '退款',
                    value: 'TK'
                },
                {
                    label: '商家退款',
                    value: 'SJTK'
                },
            ],
            statusOptions: [
                { label: '审核中', value: 'CHECKING' },
                { label: '待退货', value: 'WAIT_SALE' },
                { label: '退货中', value: 'SALEING' },
                { label: '退款中', value: 'REFUNDING' },
                { label: '退款成功', value: 'FINISH' },
                { label: '驳回', value: 'REJECT' },
                { label: '关闭', value: 'CANCEL' },
            ],

            dialogVisible: false,
            textarea: '',
            imageList: [],
            formTool: {
                payShopName: '',
                orderCode: '',
                code: '',
                keyWords: '',
                status: ''
            },
            operation: false,
            selection: false,
            index: false,
            tableData: [
            ],
            tableOption: [

                { label: '申请人', prop: 'payShopName' },
                { label: '诊所联系方式', prop: 'contactsPhone' },
                { label: '售后商品', prop: 'goodsName' },
                { label: '售后单据类型', prop: 'type', width: '100px' }, // 这里表示自定义列, slot: true
                { label: '申请时间', prop: 'orderTime' },
                { label: '订单编号', prop: 'orderCode' },
                { label: '售后单号', prop: 'code' },
                { label: '售后商户', prop: 'payeeShopName' },
                { label: '商户联系方式', prop: 'payeeShopPhone' },
                { label: '处理倒计时', prop: 'countDownTime',slot:true },
                { label: '当前状态', prop: 'status', slot: true },
                { label: '操作', prop: 'caozuo', slot: true, width: '200px', align: 'center' }
            ],
            page: {
                total: 10,
                current: 1,
                size: 10
            }
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getList()
    },
    mounted() {

    },
    methods: {
        // 查询
        getList(current) {
            if (current) {
                this.page.current = current
            }
            let params = {
                ...this.formTool,
                size: this.page.size,
                current: this.page.current,
            }
            getOpsAfterSalesOrders(params).then(res => {
                if (res.records && res.records.length) {
                    this.tableData = res.records
                    this.page.total = res.total
                } else {
                    this.tableData = []
                    this.page.total = 0
                }
            })
        },
        // 重置查询条件
        reset() {
            // this.formTool.storeName = ''
            this.$refs.formTool.resetFields()
            this.formTool = { payShopName: '', orderCode: '', code: '', keyWords: '', status: '' }
            this.page.current = 1
            this.getList()
        },

        // 查看详情
        detail(row) {
            this.$router.push({ path: '/ordercenter/ordercenter-afterSalesDocumentDetail', query: { afterSaleId: row.id } })
        },
        handleExpand() { 
            this.expanded = !this.expanded;
        },
        hilarity(e,index) { 
        
        },
    }
}
</script>
<style lang='scss' scoped>
.comContent {
    padding: 0px;
}

.expand {
    &_box {
        padding: 20px 30px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    &_li {
        position: relative;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        width: 45%;
        margin-right: 3%;
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 10px;
        word-break: break-all;

        strong {
            margin-right: 10px;
            font-weight: 400;
            color: #000;
        }

        span {
            color: #666;
        }

        &_more {
            position: relative;
        }

        &_link {
            color: #f5222d;

            &:hover {
                color: #3db4b9;
            }
        }

        &_img {
            width: 100px;
            height: 100px;
        }
    }
}

.center {
    margin: 0 24px;
    height: calc(100% - 120px);
}

.myTabs {
    height: 56px;
    padding: 0 24px;
    border-bottom: 1px solid #f5f5f5 !important;
}

.topHeader {
    padding: 20px 24px 10px;
    display: flex;
    text-align: left;
    justify-content: space-between;
    align-items: center;
   // height: 56px;
    line-height: 56px;
}

.el-form-item {
    display: flex;
    align-items: center;
    margin-bottom: 0px !important;
}

.rt-btn {
    display: flex; 
    justify-content: flex-end;
}

.serach-lf {
 //width: 50%;
 display: flex;
 justify-content: flex-start;
}
</style>
  